export default __webpack_public_path__ + "static/media/appLogo.d2d321ea.png";